import BaseApi, { FetchMethodType } from 'api/BaseApi';
import { IAuthResponse } from 'api/digifi/auth/AuthTypes';
import { HttpStatusCode } from 'enums/HttpStatusCode';
import { RequestError } from 'errors/RequestError';
import TokenUtils from 'utils/TokenUtils';

export interface ISessionsApi {
  signIn(email: string, password: string): Promise<IAuthResponse>;
  logout(): Promise<void>;
  validateToken(): Promise<void>;
}

export default class SessionsRestApi extends BaseApi implements ISessionsApi {
  public signIn(email: string, password: string): Promise<IAuthResponse> {
    return this.fetch('/sessions', {
      method: FetchMethodType.POST,
      body: {
        email,
        password,
      },
    });
  };

  public logout(): Promise<void> {
    return this.fetch('/sessions', {
      method: FetchMethodType.DELETE,
    });
  }

  public validateToken(): Promise<void> {
    if (!TokenUtils.getAccessToken()) {
      throw new RequestError('No refresh token was found', HttpStatusCode.BadRequest);
    }

    return this.fetch('/sessions/token-status', {
      method: FetchMethodType.PUT,
    });
  }
}
